<template>
    <el-dialog :modal-append-to-body="false" title="自定义菜单" :visible.sync="visible" :close-on-click-modal="false" width="980px" @close="close">
    <div class="meau--container">
        <div class="meau-conBody">
            <!-- 用户管理左侧树结构 -->

            <div class="left">
                <div class="header-brand">
                    <div class="brand">
                        <span>品牌 : </span><label>{{hhg.brandIdentify}}</label>
                    </div>
                    <div class="brandName">
                        <span>品牌名称 : </span><label>{{hhg.brandName}}</label>
                    </div>
                </div>
                <div class="border_box">
                    <h3 class="tree-h3">自定义菜单
                        <el-button @click="() => showadd()" type="text">
                            <i class="el-icon-plus"></i>
                        </el-button>
                    </h3>
                    <el-tree
                        style="margin: 20px 0"
                            :data="menuList"
                            :props="defaultProps"
                            node-key="id"
                            default-expand-all
                            @node-drag-start="handleDragStart"
                            @node-drag-enter="handleDragEnter"
                            @node-drag-leave="handleDragLeave"
                            @node-drag-over="handleDragOver"
                            @node-drag-end="handleDragEnd"
                            @node-drop="handleDrop"
                            @node-click="currentlySelected"
                            draggable
                            :allow-drop="allowDrop"
                            :allow-drag="allowDrag">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                  <span class="item_name">
                      <i :class="data.menuIco"></i>
                      <span class="menuName">
                        {{ node.label }}
                      </span>
                      <span v-if="data.menuType == 'menu'" style="color: #0F81FB;">(菜单)</span>
                      <span v-if="data.menuType == 'button'" style="color: #E6A23C;">(按钮)</span>
                      <span v-if="data.menuType == 'auth'" style="color: #ff4949;">(授权)</span>
                  </span>
                  <span>
                    <i class="el-icon-plus"
                        v-if="getItemLevel(node.data)<3"
                        @click.stop="showadd(node)
                    "></i>
                    <i class="el-icon-edit" v-if="data.brandId" @click.stop="showedit(node)"></i>
                    <i class="el-icon-delete" v-if="data.brandId" @click.stop="deleteAuth(node)"></i>
                  </span>
                </span>
                    </el-tree>
                </div>

            </div>
            <!-- 用户管理右侧树结构 -->
            <div class="right">
                <manageAuth ref="manageAuth" @commit="commitAuth" style="margin-left: 20px;" :showAuthButton="showAuthButton"/>
            </div>
        </div>


    </div>
    </el-dialog>
</template>

<script>
    import { mapGetters } from "vuex";
    import IconSelect from '../../components/IconSelect/index';
    import manageAuth from '../../components/manageAuth';

    export default {
        components: {
            IconSelect,
            manageAuth
        },
        created() {
            // this.getMenuList()
        },
        // props: ['brandId','objBrand'],
        data() {
            return {
                visible: false,
                brandId: "",
                objBrand: "",
                hhg: {},
                data: [],
                defaultProps: {
                    children: 'nodes',
                    label: 'menuName'
                },
                menuList: [],
                originMenuList: []
            }
        },
        computed: {
            ...mapGetters([
                "userInfo"
            ]),
            showAuthButton() {
                let showAuth = null;
                if (this.userInfo.userType == 1) {
                    showAuth = null;
                } else if (this.userInfo.userType == 2) {
                    showAuth = ["menu"];
                }
                return showAuth;
            }
        },
        watch: {
            brandId: 'getMenuList',
            objBrand: {
                handler(newValue,oldValue) {
                    this.hhg = newValue
                },
                deep: true,
                immediate: true
            },
            "formData.viewUrl": {
                handler(newValue, oldValue){
                    if(newValue.length>0){
                        this.formData.menuUrl = "/iframe";
                    }else{
                        this.formData.menuUrl = "";
                    }
                },
            }
        },
        mounted() {
        },
        methods: {
            // 获取一个项的层级
            getItemLevel(data) {
                let {parentMenuId} = data;
                let level = 1;
                let menuList = this.originMenuList;
                function searchParentId(id){
                    for(let menu of menuList){
                        if(menu.menuId == id){
                            level ++;
                            searchParentId(menu.parentMenuId);
                        }
                    }
                }
                searchParentId(parentMenuId);
                return level;
            },
            close(){
                this.$refs.manageAuth.close();
                Object.assign(this.$data, this.$options.data.call(this));
            },
            showadd(param) {
                let data = null;
                if (param) data = param.data;
                this.manageAuthOpen("create", data);
            },
            showedit(param) {
                this.manageAuthOpen("update", param.data);
            },
            // 点出行事件
            currentlySelected(data) {
                console.log("行事件")
                console.log(data);
                this.manageAuthOpen("view", data);
            },
            manageAuthOpen(operType,data){
                // if(this.batchAuthState) return false;
                this.$refs.manageAuth.openManageAuth(operType, data);
            },

            // 提交修改或新增auth
            commitAuth(type, data){
                if(type == "create"){
                    this.addMenu(data);
                }
                if(type == "update"){
                    this.editMenu(data);
                }
                console.log(`提交类型:${type}`);
                console.log(data);
            },


            openCustomMenu(brandData){
                this.brandId = brandData.brandId;
                this.objBrand = brandData;
                this.visible = true;
            },
            importOriData() {
            },
            // 获取自定义菜单 并通过用户类型过滤数据
            getMenuList() {
                this.$api.getMenuBranCustom(this.brandId).then(res => {
                    // console.log(res);
                    let code = res.errcode
                    if (code == 0) {
                        this.originMenuList= res.data.filter(item => {
                            // return item.menuTYpe === "menu"
                            if (this.userInfo.userType == 2) {
                                if(item.menuType === "menu") {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            }
                            return true;
                        });
                        console.log(this.originMenuList)
                        // console.log(menuListSource);
                        this.menuList = this.translateDataToTree( this.originMenuList);
                    }
                }).catch(() => {
                })
            },
            addMenu(data) {
                this.$api.getMenuSaves({
                    ...data,
                    brandId: this.brandId,
                    isOpen: "0",
                    orderNumber: 10000
                    // ...this.formData
                }).then(res => {
                    if (res.errcode == 0) {
                        this.$message.success('添加成功!')
                        this.getMenuList()
                    }
                }).catch(res => {
                })
            },
            editMenu(data) {
                console.log(data);
                this.$api.getMenuUpdates({
                    ...data,
                    brandId: this.brandId,
                    isOpen: "0",
                    // ...this.editData
                }).then(res => {
                    if (res.errcode == 0) {
                        this.$message.success('修改成功!')
                        this.getMenuList()
                    }
                }).catch(res => {
                })
            },
            removeMenu(param) {
                this.$api.getMenuDeletes(param.data.menuId).then(res => {
                    if (res.errcode == 0) {
                        this.getMenuList()
                    }
                }).catch(res => {
                })
            },
            deleteAuth(param) {
                this.$confirm('一旦删除，该条菜单将永久消失。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.removeMenu(param)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            },
            Dragopen(param) {
                this.$confirm('确定要移动此菜单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.editMenu(param)
                }).catch(() => {
                    this.getMenuList()
                    this.$message({
                        type: 'info',
                        message: '已取消拖拽'
                    });
                });
            },
            selectedAdd(name) {
                this.formData.menuIco = name
            },
            selected(name) {
                this.editData.menuIco = name
            },

            handleDragStart(node, event) {
                this.$refs.manageAuth.close();
            },
            handleDragEnter(draggingNode, dropNode, ev) {
            },
            handleDragLeave(draggingNode, dropNode, ev) {
            },
            handleDragOver(draggingNode, dropNode, ev) {
            },
            handleDragEnd(draggingNode, dropNode, dropType, ev) {
                // 拖入目标节点，操作完成后，层级不能超过三层
                if(dropType == "inner"){
                    let targetLevel = this.getItemLevel(dropNode.data);

                    /*
                    lv 当前已有层数
                     */
                    function compareSonLevel(nodes,lv){
                        let maxLevel = 3; // 最大层级
                        if(nodes === null) return lv < maxLevel;
                        console.log(nodes);
                        let sonLevel = 0;
                        let rs = false;
                        function recursionNode(nodes){
                            console.log(nodes);
                            if(rs) return;
                            if(nodes === null){
                                console.log(sonLevel);
                                if(sonLevel + lv < maxLevel) rs = true;
                                return;
                            }else if(nodes.length > 0){
                                sonLevel ++
                            }
                            for(let _node of nodes){
                                console.log(_node);
                                recursionNode(_node.nodes);
                            }
                            sonLevel --;
                        }
                        if(nodes.length> 0){
                            recursionNode(nodes);
                        }
                        return rs;
                    }
                    if(!compareSonLevel(draggingNode.data.nodes,targetLevel)) {
                        this.$message({
                            message: "层级最多为三层",
                            type: "warning"
                        })
                        this.getMenuList();
                        return false;
                    }
                    console.log(compareSonLevel(draggingNode.data.nodes,targetLevel));
                }
                // 获取menuId所在的父对像
                function getMenuList(menuList,menuId){
                    if(!menuId)return menuList;
                    let rs;
                    function searchList(list){
                        for(let item of list){
                            if(item.menuId == menuId){
                                rs = item.nodes;
                                break;
                            }
                            if(item.nodes !== null)
                                searchList(item.nodes);
                        }
                    }
                    searchList(menuList);
                    return rs;
                }

                let _data = draggingNode.data;
                let targetId;

                switch(dropType){
                    case "inner":
                        targetId = dropNode.data.menuId;
                        break;
                    case "before":
                    case "after":
                        targetId = dropNode.data.parentMenuId;
                    default: break;
                }

                _data.parentMenuId = targetId;
                this.editMenu(_data);
                let needSoftList = getMenuList(this.menuList,targetId);
                let sortQuery = [];
                for(let i = 0; i < needSoftList.length; i++){
                    sortQuery.push([
                        needSoftList[i].menuId,
                        (10000 + i + 1).toString(),
                        // needSoftList[i].menuName,
                    ])
                }
                this.$api.menuUpdateSort({
                    menuSorts: sortQuery
                })
                // console.log(sortQuery);

            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
            },
            allowDrop(draggingNode, dropNode, type) {
                return true;
            },
            allowDrag(draggingNode) {
                return true;
            },
            translateDataToTree(arr) {
                let _arr = arr;
                // 列表中不显示除菜单权限以外的授权
/*                 _arr = arr.filter(item => {
                    item.menuType == "menu"
                }); */
                // 转换成树型结构
                return _arr.filter((father) => {
                    let branchArr = _arr.filter((child) => father.menuId == child.parentMenuId)
                    branchArr.length > 0 ? father.nodes = branchArr : ""
                    return father.parentMenuId == ''
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .meau--container {
        padding: 0 20px;
        .meau-conBody {
            display: flex;
            justify-content: space-between;

            .left {
                width: 35%;

                .tree-h3 {
                    height: 44px;
                    line-height: 44px;
                    background: #F6F7F9;
                    border-radius: 4px 4px 0px 0px;
                    border: 1px solid #E8E8E8;
                    padding-left: 24px;
                    color: #3C4353;
                }

                .el-icon-plus {
                    color: #409eff
                }

                .el-icon-edit {
                    color: #409eff;
                    margin-left: 10px;
                }

                .el-icon-delete {
                    color: #409eff;
                    margin-left: 10px;
                }
                .border_box {
                    border-radius: 4px 4px 0px 0px;
                    border: 1px solid #E6E9EF;
                }
                .header-brand {
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .brand {
                        span {
                            color: #337EFF;
                        }
                    }
                    .brandName {
                        span {
                            color: #337EFF;
                        }
                    }
                }
            }

            .right {
                width: 58%;
                .header-brand {
                    height: 50px;
                }
                .menu-add {
                    padding-left: 30px;
                    border-radius: 4px 4px 0px 0px;
                    border: 1px solid #E6E9EF;
                    .add-h3 {
                        height: 44px;
                        line-height: 44px;
                        margin-left: -30px;
                        background: #F6F7F9;
                        border-radius: 4px 4px 0px 0px;
                        border: 1px solid #E8E8E8;
                        padding-left: 30px;
                        color: #3C4353;
                        margin-bottom: 20px;
                    }
                }

                .menu-edit {
                    padding-left: 30px;
                    border-radius: 4px 4px 0px 0px;
                    border: 1px solid #E6E9EF;
                    .edit-h3 {
                        height: 44px;
                        line-height: 44px;
                        margin-left: -30px;
                        background: #F6F7F9;
                        border-radius: 4px 4px 0px 0px;
                        border: 1px solid #E8E8E8;
                        padding-left: 30px;
                        color: #3C4353;
                        margin-bottom: 20px;
                    }
                }
            }

            .custom-tree-node {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                padding-right: 8px;
            }

            .el-select, .el-input {
                width: 75%;
            }
        }
        .footer {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }

    }
    .item_name{
        display: flex;
        align-item: center;
        width: 100%;
    }
    .menuName{
        display: inline-block;
        max-width: 120px;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        line-height: 22px;
    }
</style>